import ContactForm from './ContactForm';

export default {
  edit: ContactForm
};
